let lodopInited = false;

function initLodop() {
	if (lodopInited) return;
	lodopInited = true;
	let head = document.head || document.getElementsByTagName('head')[0] || document.documentElement;
	[8000, 18000].forEach(item => {
		let oscript = document.createElement('script');
		oscript.src = `http://localhost:${item}/CLodopfuncs.js`;
		head.insertBefore(oscript, head.firstChild);
	});
	[8443].forEach(item => {
		let oscript = document.createElement('script');
		oscript.src = `https://localhost.lodop.net:${item}/CLodopfuncs.js`;
		head.insertBefore(oscript, head.firstChild);
	});
}

function getLodop(oOBJECT, oEMBED) {
	return new Promise((resolve, reject) => {
		var strCLodopInstall = '在线打印Excel模板需要CLodop云打印服务！<a style="color: #00f" href="//cdn.ycmes.cn/static/ycmes/lodop/CLodop_Setup_for_Win64NT.exe" target="_self">点击这里下载并安装</a>，安装后请刷新页面。';
		var strCLodop32Install = '在线打印Excel模板需要CLodop云打印服务！<a style="color: #00f" href="//cdn.ycmes.cn/static/ycmes/lodop/CLodop_Setup_for_Win32NT.exe" target="_self">点击这里下载并安装</a>，安装后请刷新页面。';
		var LODOP;

		try {
			try {
				LODOP = getCLodop();
			} catch(e) {}

			if (!LODOP) {
				if (navigator.userAgent.indexOf('win32') >= 0 || navigator.userAgent.indexOf('wow32') >= 0) {
					reject(strCLodop32Install);
				} else {
					reject(strCLodopInstall);
				}
			} else {
				if (oEMBED && oEMBED.parentNode) oEMBED.parentNode.removeChild(oEMBED);
				if (oOBJECT && oOBJECT.parentNode) oOBJECT.parentNode.removeChild(oOBJECT);
			}
			
			if (LODOP.VERSION >= '6.2.1.8') {
				LODOP.SET_LICENSES("", "5DC0310CA9097C706C838BA67FA227EF414", "", "");
			}

			resolve(LODOP);
		} catch(e) {
			reject(`getLodop出错：${e}`);
		}
	});
};

export {initLodop, getLodop};